module.exports = __webpack_public_path__ + "static/media/gujrati.533e20e6.jpeg";